import { Injectable, effect, inject } from '@angular/core';
import { AuthStore } from '../../../../core/auth/state/auth.store';
import { isHeyJivuDesktop } from '../../../../core/constants/runtime.constants';
import { LocalAiDesktopBridgeService } from './local-ai-desktop-bridge.service';

const SYNC_INTERVAL_MS = 120_000;
const FIRST_SYNC_DELAY_MS = 15_000;

/**
 * Desktop status observer. Electron owns the encrypted device credential,
 * heartbeat, and 30-second job claim loop. Angular never handles tunnel URLs
 * or the plaintext device key.
 */
@Injectable({ providedIn: 'root' })
export class LocalAiDesktopSyncService {
  private readonly authStore = inject(AuthStore);
  private readonly bridge = inject(LocalAiDesktopBridgeService);
  private timerId: ReturnType<typeof setInterval> | null = null;
  private syncing = false;

  constructor() {
    effect(() => {
      if (isHeyJivuDesktop() && this.authStore.isAuthenticated()) void this.syncOnce();
    });
  }

  start(): void {
    if (!isHeyJivuDesktop() || this.timerId !== null) return;
    setTimeout(() => void this.syncOnce(), FIRST_SYNC_DELAY_MS);
    this.timerId = setInterval(() => void this.syncOnce(), SYNC_INTERVAL_MS);
  }

  private async syncOnce(): Promise<void> {
    if (this.syncing) return;
    this.syncing = true;
    try { await this.bridge.deviceStatus(); }
    catch { /* Best effort; the Electron loop reconnects independently. */ }
    finally { this.syncing = false; }
  }
}
